// extracted by mini-css-extract-plugin
export var avatarContainer = "_7t-0";
export var avatarTypingWave = "_7t-i";
export var gray = "_7t-f";
export var green = "_7t-c";
export var icon = "_7t-9";
export var image = "_7t-1";
export var lg = "_7t-6";
export var md = "_7t-5";
export var presenceDot = "_7t-b";
export var red = "_7t-d";
export var sm = "_7t-4";
export var status = "_7t-a";
export var typingDot = "_7t-h";
export var typingPill = "_7t-g";
export var xl = "_7t-7";
export var xs = "_7t-3";
export var xxl = "_7t-8";
export var xxs = "_7t-2";
export var yellow = "_7t-e";